<template>
  <div class="guidance-modal" v-if="showGuidance">
    <div
      class="solid"
      v-if="guidanceStep[step].solid || instep"
      @click="tap"
    ></div>
    <div
      :class="['guidance', { showBg: bgDisable }]"
      :style="style"
      @click="guidanceStep[step].tapAll && tap()"
    >
      <transition name="fade">
        <div class="text" :style="textStyle" v-if="showText">
          {{ T(guidanceStep[step].guidanceText.text) }}
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
export default {
  // 新手引导组件
  name: "guidance",
  props: {
    guidanceStep: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      step: -1, // 当前进度
      showGuidance: false,
      style: {},
      textStyle: {},
      regetTurns: 0,
      nextTurns: 0,
      bgDisable: false,
      bodyClientRect: document.body.getBoundingClientRect(),
      instep: true, // 是否在执行中
      showText: false,
      maxTurns: 60, // 捕获dom最大次数
      moveToTarget: false, // 是否将聚焦点移动到屏幕内 不能在使用了页面自适应代码的页面一起使用
    };
  },
  watch: {
    instep(newVal) {
      if (newVal) {
        this.bgDisable = true;
      } else {
        this.bgDisable = false;
      }
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.step = -1;
    },
    async start(moveToTarget = false) {
      this.moveToTarget = moveToTarget;
      this.step = 0;
      this.showGuidance = true;
      await this.util.sleep(100);
      await this.setBlock();
      this.instep = false;
      // 如果需要监听事件执行下一步的话
      if (!this.guidanceStep[0].solid) {
        this.guidanceStep[0].nextFn.call(this);
      }
      window.addEventListener(
        "resize",
        this.util.debounce(() => {
          this.regetTurns = 0;
          this.setBlock();
        }, 200)
      );
    },
    async doNext(count) {
      this.showText = false;
      if (count != this.guidanceStep.length) {
        this.step = count;
        if (!this.guidanceStep[this.step].solid) {
          this.guidanceStep[this.step].nextFn.call(this);
          await this.util.sleep(300);
        }
        if (this.guidanceStep[this.step].delay) {
          await this.util.sleep(this.guidanceStep[this.step].delay);
        }
        this.regetTurns = 0;
        this.$nextTick(this.setBlock);
        await this.util.sleep(500);
        this.instep = false;
      } else {
        this.step = 0;
        // this.setBlock();
        this.style = {
          clipPath: `polygon(0% 0%, 0% 100%, 0 100%, 0 0, 100% 0, 100% 100%, 0 100%, 0 100%, 100% 100%, 100% 0%)`,
          "-webkit-clip-path": `polygon(0% 0%, 0% 100%, 0 100%, 0 0, 100% 0, 100% 100%, 0 100%, 0 100%, 100% 100%, 100% 0%)`,
        };
        this.hide();
      }
    },
    async setBlock() {
      this.instep = true;
      this.bodyClientRect = document.body.getBoundingClientRect();
      if (!this.guidanceStep[this.step].target()) {
        this.$Spinner.showLoading(false, false, false, true);
        // 防止获取不到对象
        if (this.regetTurns > this.maxTurns) {
          if (this.nextTurns >= this.guidanceStep.length) {
            this.$toast("系统错误");
            this.$eventHub.$emit(this.$route.path + "/guidanceError");
            this.hide();
            this.$Spinner.hideLoading();
          } else {
            this.maxTurns = 1;
            this.nextTurns++;
            this.doNext(++this.step);
            this.$Spinner.hideLoading();
          }
        } else {
          this.regetTurns++;
          await this.util.sleep(100);
          this.setBlock();
        }
        return Promise.resolve();
      }
      if (this.moveToTarget) {
        // 聚焦元素进入视野
        this.guidanceStep[this.step].target().scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "center",
        });
        await this.util.sleep(500);
      }
      this.maxTurns = 60;
      this.$Spinner.hideLoading();
      let targetDom = this.guidanceStep[this.step]
        .target()
        .getBoundingClientRect();
      let targetDomLeft =
          targetDom.left - this.util.rem2px(0.1) - this.bodyClientRect.left,
        targetDomTop =
          targetDom.top - this.util.rem2px(0.1) - this.bodyClientRect.top,
        targetDomRight = this.bodyClientRect.right - targetDom.right,
        dot3X = targetDomLeft,
        dot4X = targetDomLeft,
        dot4Y = targetDomTop,
        dot5X = targetDomLeft + targetDom.width + this.util.rem2px(0.2),
        dot5Y = targetDomTop,
        dot6X = dot5X,
        dot6Y = targetDomTop + targetDom.height + this.util.rem2px(0.2),
        dot7X = targetDomLeft,
        dot7Y = dot6Y,
        dot8X = targetDomLeft;

      let textAlign = this.guidanceStep[this.step].guidanceText.textAlign;
      this.textStyle = {
        position: "absolute",
        width:
          targetDom.width < this.util.rem2px(3)
            ? `${this.util.rem2px(3)}px`
            : `${targetDom.width + this.util.rem2px(0.3)}px`,
        textAlign,
      };
      if (this.guidanceStep[this.step].guidanceText.position == "top") {
        this.textStyle.bottom = `${
          window.innerHeight - dot4Y + this.util.rem2px(0.1)
        }px`;
      } else {
        this.textStyle.top = `${
          targetDom.height + targetDomTop + this.util.rem2px(0.3)
        }px`;
      }
      if (textAlign == "left") {
        this.textStyle.left = `${targetDomLeft}px`;
      } else if (textAlign == "right") {
        this.textStyle.right = `${targetDomRight}px`;
      } else {
        this.textStyle.left = `${targetDomLeft}px`;
        this.textStyle.right = `${targetDomRight}px`;
      }

      this.style = {
        clipPath: `polygon(0% 0%, 0% 100%, ${dot3X}px 100%, ${dot4X}px ${dot4Y}px, ${dot5X}px  ${dot5Y}px, ${dot6X}px ${dot6Y}px, ${dot7X}px ${dot7Y}px, ${dot8X}px 100%, 100% 100%, 100% 0%)`,
        "-webkit-clip-path": `polygon(0% 0%, 0% 100%, ${dot3X}px 100%, ${dot4X}px ${dot4Y}px, ${dot5X}px  ${dot5Y}px, ${dot6X}px ${dot6Y}px, ${dot7X}px ${dot7Y}px, ${dot8X}px 100%, 100% 100%, 100% 0%)`,
      };

      this.showText = true;
    },
    hide() {
      this.showGuidance = false;
    },
    tap() {
      if (!this.instep) {
        this.guidanceStep[this.step].nextFn.call(this);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.solid {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 9998;
}

.guidance {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 9999;
  width: 100%;
  height: 100%;
  transition: all 0.3s ease-in-out;
  background: rgba(0, 0, 0, 0.7);
  clip-path: polygon(
    0% 0%,
    0% 100%,
    0 100%,
    0% 0%,
    100% 0%,
    100% 100%,
    0% 100%,
    0% 100%,
    100% 100%,
    100% 0%
  );
  overflow: hidden;
  .text {
    margin: 0.2rem 0;
    min-width: 3rem;
    font-size: 0.36rem;
    color: #fff;
    opacity: 1;
    transition: opacity 0.2s;
  }

  &.showBg {
    background: rgba(0, 0, 0, 0);

    .text {
      opacity: 0;
    }
  }
}
</style>